import { appApiFormDataHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const POST_UPLOAD_IMAGE = 'POST_UPLOAD_IMAGE'
export const uploadImageApi = apiCall(
  POST_UPLOAD_IMAGE,
  ({ siteId, formData }: { siteId: string; formData: FormData }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/images`),
    method: 'POST',
    body: formData,
    headers: appApiFormDataHeaders(),
  }),
)
